import { getMoviesListApi } from "../../constants/apiConstants";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import request from "../../utils/request";
export const getMovies = createAsyncThunk(
    "moviesListReducer/movies",
    async ({dispatch}) => {
      try {
        const res = await request({
          url: getMoviesListApi.getMovies,
          method: "GET",
        });
        return res;
      } catch (error) {
        throw error;
      }
    }
  );
const moviesSlice = createSlice({
  name: "getMovies",
  initialState: {
    movies: null,
    moviesLoading: false,
  },
  reducers: {
    moviesRes: (state, action) => {
      state.movies = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMovies.pending, (state) => {
        state.moviesLoading = true;
      })
      .addCase(getMovies.fulfilled, (state, action) => {
        state.moviesLoading = false;
        state.movies = action.payload;
      })
      .addCase(getMovies.rejected, (state) => {
        state.moviesLoading = false;
      });
  },
});

export const { moviesRes } = moviesSlice.actions;
export default moviesSlice.reducer;
